// 菜单路由
// 路由名称与 shop_menu 表中配置路径的最后一个元素一一对应
import Dashboard from '@/view/base/index' // 首页仪表盘
import Shopwxshop from '@/view/base/shop/wxshop' // 微信门店管理
import Wxshopsetting from '@/view/base/shop/shopsetting' // 门店信息配置
import Comments from '@/view/base/shop/comments' // 门店评论
import Assetpayment from '@/view/base/setting/payment' // 微信支付账户配置
import Assetaccountactivation from '@/view/base/asset/accountactivation/index' // 订购续费
import Datamessage from '@/view/base/shortmessage/index' // 短信账户
import Staffleader from '@/view/base/shopstaff/salesperson/leaderlist' // 门店管理员
import Accountmanagement from '@/view/base/account/management' // 平台管理员 --
import Accountroles from '@/view/base/account/roles' // 角色管理 --
import Basearticle from '@/view/base/article/index' // 文章管理
import Basecurrency from '@/view/base/currency/index' // 货币管理
import Itemsflag from '@/view/base/setting/itemsflag' // 商品功能设置
import Queueinfo from '@/view/base/setting/queueinfo' // 商品功能设置
import Lbsmanager from '@/view/base/setting/lbsmanager/list' // 位置服务授权管理
import Baseexport from '@/view/base/exportlog/index' // 日志导出
import Brand from '@/view/brand/wechat/open' // 公众号授权
import Brandcustomer from '@/view/brand/wechat/customservice' // 公众号客服管理
import Brandmenu from '@/view/brand/wechat/custommenu' // 自定义公众号菜单
import Brandreply from '@/view/brand/wechat/reply' // 公众号消息自动回复设置
import Brandfans from '@/view/brand/wechat/fans' // 公众号粉丝管理
import Brandmaterial from '@/view/brand/wechat/aterialmanagement' // 素材管理
import Goodscategory from '@/view/mall/goods/category' // 商品分类
import Goodsmaincategory from '@/view/mall/goods/maincategory' // 商品分类
import Servicegoods from '@/view/mall/goods/service/index' // 服务类商品管理
import Goodsphysical from '@/view/mall/goods/physical/list' // 实体类商品
import Disabledgoodsmanager from '@/view/mall/goods/disabledgoods/list' // 禁售商品列表
import Prebuyonesfreeones from '@/view/mall/goods/prebuyonesfreeones/list' // 商品买赠活动数据预览
import Prelimitedtimesale from '@/view/mall/goods/prelimitedtimesale/list' // 商品限时特惠活动数据预览
import Goodsphysicalimage from '@/view/mall/goods/physical/imagelist' // 实体类商品
import Goodspricereview from '@/view/mall/goods/priceview' //商品价格审核
import Goodspricereviewtitle from '@/view/mall/goods/priceviewtitle' //商品价格审核设置
import Goodspricereviewlist from '@/view/mall/goods/priceviewlist' //商品价格审核详情
import Chinesemedicine from '@/view/mall/goods/package/list' // 中药模板
import Chinesemedicinecategory from '@/view/mall/goods/attributes/category' // 中药分类
import Physicalupload from '@/view/mall/goods/physical/normalGoodsUpload' // 实体商品导入
import Goodsbrand from '@/view/mall/goods/attributes/brand' // 商品品牌管理
import Servicepayment from '@/view/mall/trade/list' // 交易单管理
import Tradeservice from '@/view/mall/trade/order/list' // 服务订单管理
import Tradenormalorders from '@/view/mall/trade/normalorders/list' // 实体订单管理
import Tradenormalshoporders from '@/view/mall/trade/normalorders/shopList' // 实体订单管理
import Tradedrugorders from '@/view/mall/trade/normalorders/drugList' // 实体订单管理
import Tradepayment from '@/view/mall/trade/list' // 交易单管理
import Tradeverification from '@/view/mall/trade/salesmanWorkRecords' // 服务核销单
import Shippingtemplates from '@/view/mall/trade/shipping/templates' // 运费模版
import Marketingdistributor from '@/view/mall/marketing/distributor' // 店铺管理
import Operating_time from '@/view/mall/marketing/operating_time' // 店铺管理
import Marketingdistributor_editor from '@/view/mall/marketing/distributor_editor' // 店铺编辑
import Marketingdistribution_orders from '@/view/mall/marketing/distributionOrders' // 店铺订单
import Distributorprintdevice from '@/view/mall/marketing/distributorprintdevice' // 店铺打印设备管理

import Distributortags from '@/view/mall/marketing/distributortags' // 商品标签
import Distributorrel_items from '@/view/mall/marketing/distributorRelItems' // 店铺关联商品
import Marketinglog from '@/view/mall/marketing/distributionLog' // 店铺记录
import ShopDecoration from '@/view/mall/marketing/shopDecoration' // 微商城店铺装修
import DistributorCode from '@/view/mall/marketing/distributorCode' // 微商城店铺装修
import Marketingsalesman from '@/view/mall/marketing/salesman' // 导购员管理
import Reservationsetting from '@/view/mall/reservation/setting/index' // 预约设置
import Mallreservation from '@/view/mall/reservation/resourcesetting/index' // 预约管理
import Reservationorder from '@/view/mall/reservation/resourcesetting/reservation' // 预约单
import Mallrecharge from '@/view/mall/storeddeposit/index' // 会员账户储值
import Aftersaleslist from '@/view/mall/aftersales/list' // 售后单管理
import Member from '@/view/member/members/list' // 会员管理
import Manageinfomation from '@/view/member/registersetting/index' // 会员注册信息
import Managecard from '@/view/member/membercard/index' // 会员卡与等级设置
import Managecardorder from '@/view/member/membercard/list' // 会员卡购买记录
import Managecustomer from '@/view/member/members/uploade' // 会员信息导入 **
import Managetag from '@/view/member/members/tags' // 会员标签
import Managekaika from '@/view/member/members/kaika' // 会员开卡
import Analysisrights from '@/view/member/members/rightsList' // 会员权益管理
import Membermarketing from '@/view/member/cardticket/coupon' // 优惠券管理
import Kaquanpackage from '@/view/member/cardticket/package/list' // 优惠券券包
import Couponsend from '@/view/member/members/list' // 群发优惠券，与会员管理同一组件
import Smssend from '@/view/member/members/list' // 群发短信，与会员管理同一组件
import Coupongive from '@/view/member/coupon/giveLog' // 优惠券后台发放记录
import Yibao from '@/view/member/promotions/yibao' // 医保营销
import Marketingindex from '@/view/member/promotions/index' // 注册营销
import Marketingbargain from '@/view/member/bargain/index' // 微信助力
import Marketingactivity from '@/view/member/activity/index' // 自动化营销
import Groupsindex from '@/view/member/groups/index' // 拼团活动管理
import Popularizesetting from '@/view/popularize/setting' // 分销设置
import Promotersetting from '@/view/popularize/promoterSetting' // 推广员等级设置
import Popularizelist from '@/view/popularize/list' // 推广员列表
import Popularizewithdraw from '@/view/popularize/withdraw' // 分销提现
import Popularizegoods from '@/view/popularize/goods' // 推广商品
import PopularizegoodsAudit from '@/view/popularize/goodsAudit' // 推广商品审核
import Taskbrokerage from '@/view/popularize/taskBrokerage' // 任务佣金明细
import Taskbrokeragecount from '@/view/popularize/taskBrokerageCount' // 任务佣金统计
import Marketingcommunity from '@/view/member/promotions/community/index' // 社区管理
import Marketingcommunityactivity from '@/view/member/promotions/community/activity/index' // 活动管理
import Marketingdeliveryorder from '@/view/member/promotions/community/deliveryorder' // 配送单
import Communitysetting from '@/view/member/promotions/community/setting' // 社区活动设置
import Communitywithdraw from '@/view/member/promotions/community/withdraw' // 积分提现
import Communityactivityorder from '@/view/member/promotions/community/activity/orderList' // 社区活动订单
import Marketingseckill from '@/view/member/promotions/seckill/list' // 秒杀活动管理
import Limitedtimesale from '@/view/member/promotions/limitedtimesale/list' // 限时特惠活动管理
import Buyonesfreeones from '@/view/member/promotions/buyonesfreeones/list'// 买赠活动
// import Buyitemscards from '@/view/member/promotions/Buyitemscards/list'// 买赠活动
import Goodslimit from '@/view/member/promotions/goodslimit/list' // 商品限购管理
import Goodspresale from '@/view/member/promotions/goodspresale/list' // 商品预售管理
import Marketingsendcouponlog from '@/view/member/promotions/sendcouponlog/list' // 抽奖记录
import Wxapp from '@/view/wxapp/index' // 小程序列表
import Templateedit from '@/view/wxapp/management' // 小程序模板编辑
import Pctemplate from '@/view/pc/homePage/default' // pc首页模板编辑
import Pcviptemplate from '@/view/pc/vipPage/default' // pc vip页面模板编辑
import Pcfootertext from '@/view/pc/footerPage/default' // pc 底部文案
import Pccustompage from '@/view/pc/custompage' // pc 自定义页面
import Editcategory from '@/view/wxapp/category' // 自定义小程序分类
import Custompage from '@/view/wxapp/custompage' // 自定义小程序页面
import Customlink from '@/view/wxapp/customlink' // 自定义小程序链接页面
import Floorguide from '@/view/wxapp/floor_guide' // 自定义楼层引导页面
import Editdashboard from '@/view/wxapp/statistics/dataanalysis/index' // 小程序数据分析
import Editsourcemanagement from '@/view/wxapp/statistics/sourcemanagement/index' // 小程序千人千码
import Editauthorize from '@/view/wxapp/authorize/index' // 小程序授权
import Marketingsfulldiscount from '@/view/member/promotions/fulldiscount/list' // 满折活动列表
import Marketingsfullminus from '@/view/member/promotions/fullminus/list' // 满减活动列表
import Marketingsfullgift from '@/view/member/promotions/fullgift/list' // 满赠活动列表
import Marketingspluspricebuy from '@/view/member/promotions/pluspricebuy/list' // 加价购活动列表
import Marketingpackage from '@/view/member/promotions/package/list' // 组合促销促销
import Ordersetting from '@/view/mall/trade/ordersetting' // 订单时效配置
import Goodsattributes from '@/view/mall/goods/attributes/attributes' // 商品规格列表
import StoreshopitemanagementRelease from '@/view/mall/storeshop/itemrelease' // 店铺商品发布
import Goodsparams from '@/view/mall/goods/attributes/params' // 商品参数列表
import Storeshopitemanagement from '@/view/mall/storeshop/itemlist' // 店铺商品列表
import Merchantstaff from '@/view/base/account/storestaff' // 商城（店铺）员工管理
import Merchantstaffroles from '@/view/base/account/storeroles' // 商城（店铺）员工角色管理
import Platformstaff from '@/view/base/account/normalstaff' // 平台员工管理
import Platformstaffroles from '@/view/base/account/normalroles' // 平台员工角色管理
import Planting from '@/view/base/planting/index' // 种草列表
import Articlecolumns from '@/view/base/article/columns' // 文章栏目
import Articlegeneralcolumns from '@/view/base/article/generalcolumns' // 文章栏目

import Operatorlogs from '@/view/base/setting/companys/logs' // 商家操作日志列表

import Vipitemslist from '@/view/mall/storeshop/vipitemlist' // 付费会员商品列表

import Itemtags from '@/view/mall/goods/tags' // 商品标签
import Goodsaudit from '@/view/mall/goods/audit/list' // 商品标签
import Goodsaudit_editor from '@/view/mall/goods/audit/add' // 商品标签

import Selfdeliveryaddress from '@/view/base/address/setting' // 设置固定自提地址
import Ordercartsetting from '@/view/mall/trade/cartadsetting' // 购物车广告营销语

import Recommendlike from '@/view/member/promotions/recommendlike' // 设置固定自提地址

import Omsqueuelog from '@/view/mall/trade/omsqueuelog' // 查看oms通信日志

import Refunderrorlogs from '@/view/mall/trade/refunderrorlogs' // 退款错误日志

import Rate from '@/view/mall/trade/rate/list' // 订单评价

// jiangxd start
import Shoptypes from '@/view/base/shopstypes/list' // 设置怡康店铺类型
import Shoptypes_editor from '@/view/base/shopstypes/shoptypes_editor' // 怡康店铺编辑
import Shopcategorys from '@/view/mall/storeshop/distributionCategoryEdit' // 编辑店铺分类
// jiangxd end
import Certificate from '@/view/base/setting/certificate/index' // 授权

// np积分相关 start
import Duibauser from '@/view/duiba/members/list.vue' // 会员卡
import DuibaOrder from '@/view/duiba/orders/list.vue' // 兑吧订单
import NpPointsOrder from '@/view/duiba/points/list.vue' //积分变动列
import PointGoods from '@/view/duiba/goods/list.vue' //积分商品列表
import PointCategory from '@/view/duiba/goods/category.vue' //商品细类
import PointOrder from '@/view/duiba/orders/order.vue' //积分商品列表
import PointBasic from '@/view/duiba/points/banner.vue' //积分商品列表
// 健管
import Healthy_goods from '@/view/jianguan/goods/list.vue' //积分商品列表
import HealthyCategory from '@/view/jianguan/goods/category.vue' //商品细类
import HealthyStock from '@/view/jianguan/goods/stock.vue' //商品细类
// 第三方权益 start
import ThirdsSetting from '@/view/thirds/setting/list.vue' // 第三方权益列表
import ThirdsSetting_editor from '@/view/thirds/setting/thirdsseting_editor.vue' // 第三方权益编辑
import ThirdsLogs from '@/view/thirds/logs/list.vue' // 第三方权益日志
// 第三方权益 end
import Nppoint from '@/view/base/setting/nppoint/index.vue' // 设置积分发放配置

// import Basic_setting from '@/view/mall/marketing/basicSetting' // 基础配置
// import Onecode from '@/view/brand/codegoods/thingslist' // 商品码管理
// import Things from '@/view/brand/codegoods/thingsedit' // 新增编辑物品
// import Batchs from '@/view/brand/codegoods/batchsedit' // 批次管理&&新增编辑批次
// import Thingsbatchs_detail from '@/view/brand/codegoods/thingsbatchsdetail' //物品批次详情
// import Withdraw from '@/view/mall/marketing/withdraw' // 提现申请
// import Surveillance from '@/view/mall/marketing/surveillance' // 店铺二维码
// import Distributorlog from '@/view/mall/marketing/logByDistributor' // 商家店铺记录
// import List from '@/view/mall/reservation/resourcesetting/list' // 资源位管理
// import registerRromotionsAdd from '@/view/member/promotions/distributorEdit'
import Selformelementsetting from '@/view/member/selfservice/formsettinglist'   // 自助表单元素配置
import Selformtempsetting from '@/view/member/selfservice/formtemplatelist'     // 自助表单模板配置
// import Physicalmeasurement_detail from '@/view/member/selfservice/userdaliyrecord'   // 用户体测详情报表
import Physicalmeasurement from '@/view/member/selfservice/templatepreview'     // 用户体测列表和配置

import Registrationactivity from '@/view/member/selfservice/registrationactivity'     // 报名活动管理
import Registrationactivity_editor from '@/view/member/selfservice/registrationactivityadd'     // 报名活动管理
import Registrationrecord from '@/view/member/selfservice/registrationrecord'     // 报名记录管理
import Registrationrecord_detail from '@/view/member/selfservice/registrationrecordetail'     // 报名记录管理
import Registrationrecord_editor from '@/view/member/selfservice/regRecordUpload'    //报名审核结果上传日志

// 财务
import Statementlist from '@/view/mall/trade/statementlist' // 第三方对账单

// 企业微信 ====
// import Workwx_auth from '@/view/workwx/authorize' // 企业微信授权管理
import Workwx_list from '@/view/workwx/authorize' // 企业微信列表
import Workwx_dep from '@/view/workwx/authorize/dep' // 企业微信列部门列表
import Workwx_share_log from '@/view/workwx/authorize/share' // 分享列表
import Workwx_employee from '@/view/workwx/authorize/employee' // 企业成员列表
import Permanent_code from '@/view/workwx/permanent' // 企业授权信息
import Third_app from '@/view/workwx/thirdapp' // 第三方应用
import Workwx_contact from '@/view/workwx/contact' // 微信客户
import Workwx_contact_tag from '@/view/workwx/tag' // 客户标签
import Workwx_groupmsg_list from '@/view/workwx/groupmsg' // 群发消息
import Wechat_room from '@/view/workwx/group' // 客户群
import Workwx_moment from '@/view/workwx/moment' // 客户朋友圈
// 隐藏路由
import Home from '@/view/home' // 主框架
import Layout from '@/view/layout' // 主结构
import Authloading from '@/view/authloading' // 绑定微信
import Shopwxshop_editor from '@/view/base/shop/editshop' // 添加修改门店
import Basearticle_editor from '@/view/base/article/editor' // 添加编辑文章
import Brandmaterial_editor from '@/view/brand/wechat/artical/new_artical' // 新增编辑图文消息
import Servicegoods_editor from '@/view/mall/goods/service/items/add' // 服务类商品添加编辑
import Goodsphysical_editor from '@/view/mall/goods/physical/add' // 实体类商品添加编辑
import Items_areaMarketPrice_editor from '@/view/mall/storeshop/areaMarketPrice/add'  // 设置店铺商品区域划线价
import Goodsphysicalimage_editor from '@/view/mall/goods/physical/add' // 实体类商品添加编辑
import Chinesemedicine_editor from '@/view/mall/goods/package/add' // 中药模板添加编辑
import Tradenormalorders_detail from '@/view/mall/trade/order/detail' // 实体订单详情
import Tradedrugorders_detail from '@/view/mall/trade/order/detail' // 实体订单详情
import Marketingdistribution_orders_detail from '@/view/mall/trade/order/detail' // 店铺订单详情
import Tradeservice_detail from '@/view/mall/trade/order/detail' // 服务订单详情
import Shippingtemplates_editor from '@/view/mall/trade/shipping/add' // 添加编辑运费模板
import Mallreservation_editor from '@/view/mall/reservation/resourcesetting/add' // 资源位添加
import Coupongive_detail from '@/view/member/coupon/giveErrorLog' // 优惠券后台发放记录详情
import Aftersaleslist_detail from '@/view/mall/aftersales/detail' // 售后单详情
import Member_detail from '@/view/member/members/detail' // 会员详情页
import Membermarketing_detail from '@/view/member/cardticket/detail' // 优惠券领取记录
import Membermarketing_editor from '@/view/member/cardticket/edit' // 添加编辑优惠券
import Marketingbargain_editor from '@/view/member/bargain/add' // 添加编辑微信助力
import Marketingactivity_templ from '@/view/member/activity/templ' // 自动化营销选择模版
import Marketingactivity_editor from '@/view/member/activity/add' // 新增编辑自动化营销
import Groupsindex_editor from '@/view/member/groups/add' // 新增编辑拼团活动
import Groupsindex_team from '@/view/member/groups/team' // 拼团活动数据
import Groupsindex_detail from '@/view/member/groups/teamDetail' // 拼团活动团详情
import Popularizelist_child from '@/view/popularize/children' // 推广员直属下级
import Popularizelist_detail from '@/view/popularize/brokerageLog' // 推广员佣金详情
import Marketingcommunity_detail from '@/view/member/promotions/community/points' // 社区积分
import Marketingcommunity_editor from '@/view/member/promotions/community/add' // 新增编辑社区
import Marketingcommunityactivity_editor from '@/view/member/promotions/community/activity/add' // 新增编辑活动
import Communityactivityorder_detail from '@/view/mall/trade/order/detail' // 社区活动订单详情
import Marketingseckill_editor from '@/view/member/promotions/seckill/add' // 新增编辑秒杀活动
import Limitedtimesale_editor from '@/view/member/promotions/limitedtimesale/add' // 新增编辑限时特惠活动
import Buyonesfreeones_editor from '@/view/member/promotions/buyonesfreeones/add' // 编辑赠品活动
// import Buyitemscards_editor from '@/view/member/promotions/buyitemscards/add' // 编辑赠品活动
import Goodslimit_editor from '@/view/member/promotions/goodslimit/add' // 新增商品限购
import Goodspresale_editor from '@/view/member/promotions/goodspresale/add' // 商品预售管理
import Editsourcemanagement_detail from '@/view/wxapp/statistics/sourcemanagement/monito_detail'
import Marketingsfulldiscount_editor from '@/view/member/promotions/fulldiscount/add'  // 添加编辑满折活动
import Marketingsfullminus_editor from '@/view/member/promotions/fullminus/add'      // 添加编辑满减活动
import Marketingsfullgift_editor from '@/view/member/promotions/fullgift/add' // 添加编辑满赠活动
import Marketingpackage_editor from '@/view/member/promotions/package/add' // 组合促销促销
import Wxapp_templ from '@/view/wxapp/template' // 开通小程序模板
import Wxapp_templ_send_log from '@/view/wxapp/wxapp_templ_send_log' // 开通小程序模板
import Wxapp_templ_sub from '@/view/wxapp/wxapp_templ_sub' // 开通小程序模板

import Marketingdeliveryorder_detail from '@/view/member/promotions/community/deliverydetail' // 配送单详情
import Marketingspluspricebuy_editor from '@/view/member/promotions/pluspricebuy/add' // 加价购活动编辑
import Shopexerp from '@/view/base/setting/shopexerp' // 商派erp直连配置
import Planting_editor from '@/view/base/planting/editor' // 添加编辑种草
import Admininfo from '@/view/base/shop/admininfo' // 管理员信息
import Yilianyun from '@/view/base/setting/yilianyun/index' // 管理员信息
import Meiqia from '@/view/base/setting/im/list' // 管理员信息
import Pointrule from '@/view/member/point/index.vue' // 管理员信息

import Selformelementsetting_editor from '@/view/member/selfservice/formsettingadd'   // 自助表单元素配置
import Selformtempsetting_editor from '@/view/member/selfservice/formtemplateadd'     // 自助表单模板配置
import Physicalmeasurement_detail from '@/view/member/selfservice/userdaliyrecord'   // 用户体测详情报表
import Couponsend_detail from '@/view/member/members/detail' // 群发优惠券会员详情页
import Coupon_category from '@/view/member/cardticket/category' //优惠券分类
import Coupon_offline from '@/view/member/cardticket/offline' //线下优惠券
import Couponlog from '@/view/member/coupon/couponLog' //线下优惠券
import Coupon_activity from '@/view/member/cardticket/couponActivity' // 优惠券合并活动
import Coupon_activity_editor from '@/view/member/cardticket/couponActivityedit' //优惠券合并活动编辑

import GiftsActivitys from '@/view/member/promotions/giftsactivity/list'// 0元购活动
import GiftsActivitys_editor from '@/view/member/promotions/giftsactivity/add' // 编辑0元购活动
import GiftsActivitysusers from '@/view/member/promotions/giftsactivity/userlimit' // 编辑0元购用户设置
import GiftsActivitys_order from '@/view/member/promotions/giftsactivity/userorder' // 编辑0元购用户参与

import LotteryActivitys from '@/view/member/promotions/lotteryactivity/list'// 转盘抽奖
import LotteryActivitys_editor from '@/view/member/promotions/lotteryactivity/add' // 编辑抽奖活动
import Activitys_log from '@/view/member/promotions/lotteryactivity/log' // 活动记录

// 店铺端页面
import Shopstorelist from '@/view/shop/storelist' // 门店列表
import Shopstorelist_editor from '@/view/shop/editstore' // 门店编辑
import Companygoods from '@/view/shop/goods/companygoods' // 门店编辑
import Memberstatistics from '@/view/mall/datacube/companydata/member' // 商城统计信息-会员
import Orderstatistics from '@/view/mall/datacube/companydata/order' // 商城统计信息-订单
import Distributordata from '@/view/mall/datacube/distributordata' // 商城统计信息-订单
import Hotkeywords from '@/view/mall/goods/hotkeywords' // 热门关键词
import Goodsstatistics from '@/view/mall/datacube/goodsdata' // 商品统计信息当前登录账户未查询到对应员工
import Financestatistics from '@/view/mall/datacube/financedata' // 财务统计信息
import Artnostatistics from '@/view/mall/datacube/artnodata' // 商品货号交易信息
import Account_detail from '@/view/merchant/account/detail' //对账明细
import Account_total from '@/view/merchant/account/total' //账单明细
import Banlancelist from '@/view/merchant/account/balance' //余额流水
import Merchantbanlance from '@/view/merchant/account/merchantbanlance' //商家余额流水
import Merchantapply from '@/view/merchant/account/apply' //账单明细
import Billingtotal from '@/view/merchant/account/billingtotal' //商家汇总
import Billingtotal_notify from '@/view/merchant/account/notify' //划款入账通知
import Merchant_transfer from '@/view/merchant/transfer/list' //转账明细

import Refundstatistics from '@/view/mall/datacube/refunddata' // 退货退款信息
import Aftersalesdata from '@/view/mall/datacube/aftersalesdata' // 指定时间段内退货退款
import Realnamestatistics from '@/view/mall/datacube/realnamedata' // 多店铺实名认证信息
import Platform from '@/view/mall/datacube/platform'  // 平台统计
import Logistics from '@/view/mall/trade/logistics'
import Noticemessage from '@/view/wxapp/messages' // 查看oms通信日志

import Nzyyactivity from '@/view/mall/storeshop/slefactivity/nzyylog' // 女子医院活动专项统计

import Kdniao from '@/view/base/setting/kdniao' // 快递配置

import Wxaindex from '@/view/base/wxa/index'

// import Live from '@/view/live/index' //直播
import Livelist from '@/view/live/list' //直播列表
// eslint-disable-next-line camelcase
import Livelist_editor_add from '@/view/live/add' //直播添加
// eslint-disable-next-line camelcase
import Livelist_editor from '@/view/live/edit' //直播添加

import Anchorlist from '@/view/live/anchor/list' //主播列表
import Anchorlist_editor from '@/view/live/anchor/add' //主播添加
import Anchorlist_editor_prenotice from '@/view/live/anchor/prenotice' //主播预告
import Anchorlist_editor_uploadvideo from '@/view/live/anchor/uploadvideo' // 视频上传
import Category from '@/view/live/category' //直播分类
import Comment from '@/view/live/comment' //评论列表
import Livestatistics from '@/view/live/statistics' //统计列表
import Receive from '@/view/live/receive' //直播领取统计
import Black from '@/view/live/black' //直播领取统计
import Inform from '@/view/member/inform' //健康告知书
import Areamanage from '@/view/areamanage/list' //大区管理
import Notice from '@/view/mall/marketing/distributornotice' //店铺公告
import Auditmember from '@/view/member/members/auditmember' //实名认证
import EpidemicControl from '@/view/mall/trade/epidemicControl' //疫情防控实名登记
import Sum_amount from '@/view/jingzhi/sumAmountdata' // ,累计保额
import Checkout_order from '@/view/jingzhi/checkoutOrder' // ,保险对账
import Distributor_alterAd from '@/view/mall/storeshop/alterAd' // 店铺弹出广告设置
import Distributor_selfActivity     from '@/view/mall/storeshop/slefactivity/list'  // 店铺自主活动列
import Distributor_selfActivity_editor from '@/view/mall/storeshop/slefactivity/edit'  // 店铺自主活动编辑
import Distributor_selfActivity_log from '@/view/mall/storeshop/slefactivity/log'     // 店铺自主活动报名日志
import Distributorfeedback from '@/view/mall/marketing/distributorfeedback'     // 店铺自主活动报名日志

import Items_areaMarketPrice from '@/view/mall/storeshop/areaMarketPrice/list'  // 店铺商品区域划线价列表
import Items_skuInfo from '@/view/mall/storeshop/skuInfo/list'  // SKU 信息查询列表

import Baoxian_user from '@/view/baoxian/zhongan/user/'     // 众安保险会员列表
import Baoxian_order from '@/view/baoxian/zhongan/order/'     // 众安保险会员列表
import Renao_user from '@/view/baoxian/renbao/user/'     // 人保会员列表
import Qmbao_user from '@/view/baoxian/qmbao/user'     // 全面保会员列表
import Sdbao_user from '@/view/baoxian/sdbao/user'     // 水滴保会员列表
import CardPool from '@/view/member/members/pool' // 会员卡池

import Taikang_tag from '@/view/baoxian/taikang/productTag/'     // 泰康保险标签列表
import Taikang_order from '@/view/baoxian/taikang/taikang_insurance_order/'     // 泰康保险标签列表
import Taikang_policy_status from '@/view/baoxian/taikang/taikang_policy_status/'     // 泰康保险标签列表
import Commercial_insurance from '@/view/baoxian/insurance/insurance/'     // 商保配置
import Zhongan_user_card from '@/view/baoxian/zhongan/userCard'     // 众安用户优惠券核销
import Zhongan_financial_reconciliation from '@/view/baoxian/zhongan/financialReconciliation'     // 众安用户优惠券核销
import Version from '@/view/base/app/version'
import Distributor_template from '@/view/wxapp/distributor_template' // 店铺模板编辑
import Jingzhi_items from '@/view/jingzhi/product/jingzhi_items' // 敬之关联保险商品
import Safeinfo from '@/view/jingzhi/product/safeinfo' // 敬之被保人信息列表

import Wxappsetting from '@/view/wxapp/setting' // 小程序相关设置

//长合约
import Long_category from '@/view/long/category' //长合约分类列表
import Long_goods from '@/view/long/goods' //长合约商品
import Long_goods_edit from '@/view/long/goods/edit' //长合约商品编辑
import Long_sign from '@/view/long/sign' //长合约签约
import Long_invite from '@/view/long/invite' //长合约健康顾问邀请列表

import Shengyibao from '@/view/mall/trade/shengyibao'
import Thirdjump from '@/view/mall/trade/thirdjump' // 会员开卡
// 代客找药
import Finddrug from '@/view/mall/trade/finddrug'
// 燕尾帽订单
import Ywmdd from '@/view/mall/trade/ywmdd'

import Kaquanrandom from '@/view/member/cardticket/random' // 优惠券随机数列表
import SetRandCardRule from '@/view/member/cardticket/setRandCardRule' // 优惠券随机规则
import Recharge_offline from '@/view/member/promotions/recharge_offline/list' // 商品限购管理
import Recharge_offline_editor from '@/view/member/promotions/recharge_offline/add' // 商品限购管理
import Recharge_offline_log from '@/view/member/promotions/recharge_offline/logs' // 商品限购管理
import Export_yga from '@/view/thirds/logs/export_yga' // 第三方权益日志

// API 开放授权
import Third_oauth from '@/view/base/setting/thirdoauth/list'
//   药关爱签约
import Yga_sign from '@/view/thirds/yga_sign' // 第三方权益日志
//   店铺推广
import Bg_img from '@/view/shop/spread/bg_img'  // 码背景
import Code from '@/view/shop/spread/content'  // 推广内容
import Spread_logs from '@/view/shop/spread/logs'  // 推广内容
import Cashback from '@/view/shop/spread/cashback'  // 推广内容Cashback
// 宣传推广
import Publicity_links from '@/view/publicity/publicity_links'  // 宣传链接管理表
import Publicity_qrcodes from '@/view/publicity/publicity_qrcodes'  // 宣传链接管理表
import Publicity_rel_members from '@/view/publicity/members'  // 宣传链接管理表

//供应商
import Merchants from '@/view/merchant/merchants/list' //供应商列表
import Merchants_edit from '@/view/merchant/merchants/edit' //供应商编辑
import Company_account from '@/view/merchant/company_account/list' //对公账户信息
import Company_account_edit from '@/view/merchant/company_account/edit' //对公账户信息新增/编辑
import Credentials from '@/view/merchant/credentials/list' //平台资质补充
import Credential_types from '@/view/merchant/credential_types/list' //平台资质补充类型
import Merchant_category from '@/view/merchant/merchant_category/list' //经营品类
import Freight from '@/view/merchant/freight/list' //配送费规则列表
import Freight_edit from '@/view/merchant/freight/edit' //配送费规则编辑

//会员签到
import MembersSigninActivity from '@/view/member/membersSigninActivity/list' // 会员管理
import MembersSigninList from '@/view/member/membersSigninActivity/signinlist' // 会员签到列表
import MembersSigninAddrecord from '@/view/member/membersSigninActivity/signinaddrecord' // 会员获取补签记录
import MembersSigninAddnums from '@/view/member/membersSigninActivity/signinaddnums' // 会员剩余补签数量
import MembersSigninAward from '@/view/member/membersSigninActivity/signinaward' // 会员签到奖励

//到店签到
import StoreSigninActivity from '@/view/member/storeSigninActivity/list' // 到店签到活动配置
import StoreSigninList from '@/view/member/storeSigninActivity/signinlist' // 到店签到记录
import StoreSigninAward from '@/view/member/storeSigninActivity/signinaward' // 到店签到奖励列表

//怡贝管理
import MembersList from '@/view/sharer/members/list' //会员列表
import MembersList_detail from '@/view/sharer/members/detail' // 会员详情页
import MemberLvList from '@/view/sharer/memberLv/list' //会员列表
import WithdrawList from '@/view/sharer/withdraw/list' //提现列表
import StafftixianList from '@/view/sharer/stafftixian/list' //员工提现列表
import FranchiseStafftixianList from '@/view/sharer/franchiseStafftixian/list' // 加盟员工奖金提现列表
import IconsList from '@/view/sharer/activity/icons_list' //活动图标列表
import ActivityList from '@/view/sharer/activity/activity_list' //活动设置列表
import ActivityList_editor from '@/view/sharer/activity/activity_add' //新增编辑活动
import SkuList from '@/view/sharer/sku/sku_list' //商品列表
import SkuCate from '@/view/sharer/sku/sku_cate' //商品分类列表
import SkuPromotecate from '@/view/sharer/sku/sku_promotecate' //商品分类列表
import ShenqingList from '@/view/sharer/hhmember/shenqing_list' //健康合伙人申请列表
import ClickList from '@/view/sharer/tongji/click_list' //分享点击列表
import TongjiJingying from '@/view/sharer/tongji/jingying' //经营统计
import TongjiTuikeRanking from '@/view/sharer/tongji/tuike_ranking' //推客排行
import TongjiQianDao from '@/view/sharer/tongji/qiandao' //员工签到管理
import BannericonList from '@/view/sharer/bannericon/list' //banner列表
import YbordersList from '@/view/sharer/yborders/list' //订单列表
import PlatformRewardList from '@/view/sharer/tongji/platform_reward_list' // 平台奖励资金明细
import RewardPendingList from '@/view/sharer/tongji/reward_pending_list' // 团长奖励待发放
import SucaiList from '@/view/sharer/activity/sucai_list' //素材模板列表
import BenfitAdvanceList from '@/view/sharer/tongji/benfit_advance_list' //优卡交易明细
import DoubleCommission from '@/view/sharer/activity/double_commission' //佣金翻倍设置
import TanchuangList from '@/view/sharer/activity/tanchuang_list' //弹窗列表

//环境变量配置
import Envconfig from '@/view/base/setting/envconfig/list' //环境变量配置
import Long_manufactor from '@/view/long/manufactor' //长合约厂家合作
import Long_manufactor_log from '@/view/long/manufactor_log' //财务对账

import Yikangcard from '@/view/member/ecard/ecard' //E卡通
import Yikangcardtype from '@/view/member/ecard/ecardtype' //E卡通类型
import Ordermonthurl from '@/view/merchant/month/list' //月结账单
import Ordercheck from '@/view/merchant/account/checkorder' //订单比对
import Ordersendcard from '@/view/member/ordercard/list' // 订单送券
import Ordersendcard_editor from '@/view/member/ordercard/edit' // 订单送券编辑
import NewCustomer from '@/view/member/cardticket/newcustomer/list' //新客
import NewCustomer_editor from '@/view/member/cardticket/newcustomer/edit' // 新客
import NewCustomer_wechatlog from '@/view/member/cardticket/newcustomer/wechatlog' // 新客
import NewCustomer_userlog from '@/view/member/cardticket/newcustomer/userlog' // 新客

//资质管理
import Distributor from '@/view/zizhi/list' //店铺资质
import Distributor_detail from '@/view/zizhi/detail' //店铺资质详情
import Items from '@/view/zizhi/itemslist' //商品资质
import Updatedian from '@/view/zizhi/updatedian' //待更新店铺资质
import Updateitems from '@/view/zizhi/updateitems' //待更新商品资质
import Noticeset from '@/view/zizhi/noticeset' //提醒设置
import Sysnc from '@/view/zizhi/sysnc' //同步日志
import Jyfw from '@/view/zizhi/jyfw' //经营范围

export default {
  Distributor,
  Distributor_detail,
  Items,
  Updateitems,
  Updatedian,
  Noticeset,
  Sysnc,
  Jyfw,
  Operating_time,
  BenfitAdvanceList,
  PlatformRewardList,
  RewardPendingList,
  SucaiList,
  DoubleCommission,
  TanchuangList,
  YbordersList,
  BannericonList,
  TongjiQianDao,
  TongjiTuikeRanking,
  TongjiJingying,
  ClickList,
  ShenqingList,
  SkuCate,
  SkuPromotecate,
  SkuList,
  ActivityList_editor,
  ActivityList,
  IconsList,
  WithdrawList,
  StafftixianList,
  FranchiseStafftixianList,
  MemberLvList,
  MembersList_detail,
  MembersList,
  MembersSigninActivity,
  MembersSigninList,
  MembersSigninAddrecord,
  MembersSigninAddnums,
  MembersSigninAward,
  StoreSigninActivity,
  StoreSigninList,
  StoreSigninAward,
  Home,
  Wxaindex,
  Layout,
  Authloading,
  Dashboard,
  Shopwxshop_editor,
  Shopwxshop,
  Wxshopsetting,
  Comments,
  Assetpayment,
  Assetaccountactivation,
  Datamessage,
  Staffleader,
  Accountmanagement,
  Accountroles,
  Basearticle,
  Basearticle_editor,
  Basecurrency,
  Itemsflag,
  Queueinfo,
  Lbsmanager,
  Baseexport,
  Brand,
  Brandcustomer,
  Brandmenu,
  Brandreply,
  Brandfans,
  Brandmaterial,
  Brandmaterial_editor,
  Goodscategory,
  Goodsmaincategory,
  Servicegoods,
  Servicegoods_editor,
  Goodsphysical,
  Disabledgoodsmanager,
  Prebuyonesfreeones,
  Prelimitedtimesale,
  Goodsphysicalimage,
  Goodsphysical_editor,
  Goodsphysicalimage_editor,
  Chinesemedicine,
  Chinesemedicine_editor,
  Chinesemedicinecategory,
  Goodsaudit,
  Goodsaudit_editor,
  Physicalupload,
  Goodsbrand,
  Servicepayment,
  Statementlist,
  Tradeservice,
  Tradenormalorders,
  Tradenormalshoporders,
  Tradedrugorders,
  Tradepayment,
  Tradeverification,
  Tradenormalorders_detail,
  Tradedrugorders_detail,
  Tradeservice_detail,
  Shippingtemplates,
  Shippingtemplates_editor,
  Marketingdistributor,
  Marketingdistributor_editor,
  Marketingdistribution_orders,
  Marketingdistribution_orders_detail,
  Distributortags,
  Distributorrel_items,
  Marketinglog,
  ShopDecoration,
  Marketingsalesman,
  Reservationsetting,
  Mallreservation,
  Mallreservation_editor,
  Reservationorder,
  Mallrecharge,
  Aftersaleslist,
  Aftersaleslist_detail,
  Member,
  Member_detail,
  Manageinfomation,
  Managecard,
  Managecardorder,
  Managecustomer,
  Managetag,
  Managekaika,
  Thirdjump,
  Baoxian_user,
  Renao_user,
  Qmbao_user,
  Sdbao_user,
  CardPool,
  Baoxian_order,
  Taikang_tag,
  Taikang_order,
  Taikang_policy_status,
  Commercial_insurance,
  Zhongan_user_card,
  Zhongan_financial_reconciliation,
  Analysisrights,
  Membermarketing,
  Couponsend,
  Couponsend_detail,
  Smssend,
  Coupongive,
  Coupongive_detail,
  Membermarketing_detail,
  Coupon_activity,
  Coupon_activity_editor,
  Yibao,
  Marketingindex,
  // registerRromotionsAdd,
  Membermarketing_editor,
  Marketingbargain_editor,
  Marketingbargain,
  Marketingactivity,
  Marketingactivity_templ,
  Marketingactivity_editor,
  Goodslimit,
  Goodslimit_editor,
  Goodspresale,
  Goodspresale_editor,
  Groupsindex,
  Groupsindex_editor,
  Groupsindex_detail,
  Groupsindex_team,
  Popularizesetting,
  Promotersetting,
  Popularizelist,
  Popularizelist_child,
  Popularizewithdraw,
  Popularizegoods,
  PopularizegoodsAudit,
  Taskbrokerage,
  Taskbrokeragecount,
  Popularizelist_detail,
  Marketingcommunity,
  Marketingcommunity_detail,
  Marketingcommunity_editor,
  Marketingcommunityactivity,
  Marketingcommunityactivity_editor,
  Marketingdeliveryorder,
  Marketingdeliveryorder_detail,
  Distributorprintdevice,
  Communitysetting,
  Communitywithdraw,
  Communityactivityorder,
  Communityactivityorder_detail,
  Marketingseckill,
  Marketingseckill_editor,
  Limitedtimesale,
  Buyonesfreeones,
  // Buyitemscards,
  Limitedtimesale_editor,
  Buyonesfreeones_editor,
  // Buyitemscards_editor,
  GiftsActivitys,
  GiftsActivitys_editor,
  GiftsActivitysusers,
  GiftsActivitys_order,
  LotteryActivitys,
  LotteryActivitys_editor,
  Activitys_log,
  Wxapp,
  Wxapp_templ,
  Templateedit,
  Editcategory,
  Floorguide,
  Custompage,
  Customlink,
  Editdashboard,
  Editsourcemanagement,
  Editsourcemanagement_detail,
  Editauthorize,
  Marketingsfulldiscount,
  Marketingsfulldiscount_editor,
  Marketingpackage,
  Marketingpackage_editor,
  Marketingsfullminus,
  Marketingsfullminus_editor,
  Marketingsfullgift,
  Marketingsfullgift_editor,
  Marketingspluspricebuy,
  Marketingspluspricebuy_editor,
  Ordersetting,
  Pctemplate,
  Pcviptemplate,
  Pcfootertext,
  Pccustompage,
  Shopexerp,
  Goodsattributes,
  Goodsparams,
  Storeshopitemanagement,
  Merchantstaff,
  Merchantstaffroles,
  Platformstaff,
  Platformstaffroles,
  Planting,
  Planting_editor,
  Articlecolumns,
  Articlegeneralcolumns,
  Itemtags,
  Selfdeliveryaddress,
  Admininfo,
  Recommendlike,
  Omsqueuelog,
  Yilianyun,
  Meiqia,
  DistributorCode,
  // Onecode,
  // Things,
  // Batchs,
  // Thingsbatchsdetail,
  // Basic_setting,
  // Withdraw,
  // Surveillance,
  // Log,
  // Distributorlog,
  // List,
  Selformelementsetting,
  Selformelementsetting_editor,
  Selformtempsetting,
  Selformtempsetting_editor,
  Shopstorelist,
  Shopstorelist_editor,
  Companygoods,
  Memberstatistics,
  Orderstatistics,
  Hotkeywords,
  Goodsstatistics,
  Financestatistics,
  Realnamestatistics,
  Refundstatistics,
  Aftersalesdata,
  Artnostatistics,
  Operatorlogs,
  Logistics,
  EpidemicControl,

  Refunderrorlogs,
  Distributordata,
  Pointrule,
  Noticemessage,
  Wxapp_templ_send_log,
  Wxapp_templ_sub,
  Kdniao,
  Rate,
  Physicalmeasurement,
  Physicalmeasurement_detail,
  Certificate,
  Registrationactivity,
  Registrationactivity_editor,
  Registrationrecord,
  Registrationrecord_detail,
  Registrationrecord_editor,
  // jiangxd start
  Shoptypes,
  Shoptypes_editor,
  Shopcategorys,
  // jiangxd end\
  Duibauser,
  DuibaOrder,
  PointGoods,
  Healthy_goods,
  PointCategory,
  HealthyCategory,
  HealthyStock,
  PointOrder,
  PointBasic,
  // PointGoods_editor,
  NpPointsOrder,
  ThirdsSetting,
  ThirdsSetting_editor,
  Nppoint,
  ThirdsLogs,
  Livelist,
  Livelist_editor,
  Receive,
  Black,
  Inform,
  Livelist_editor_add,
  Anchorlist,
  Anchorlist_editor,
  Category,
  Comment,
  Livestatistics,
  Anchorlist_editor_prenotice,
  Anchorlist_editor_uploadvideo,
  Coupon_category,
  Coupon_offline,
  Couponlog,
  Areamanage,
  Platform,
  Notice,
  Auditmember,
  Version,
  Distributor_template,
  Jingzhi_items,
  Safeinfo,
  Sum_amount,
  Checkout_order,
  Long_goods,
  Long_category,
  Long_sign,
  Long_goods_edit,
  Shengyibao,
  Finddrug,
  Ywmdd,
  Distributor_alterAd,
  Distributor_selfActivity,
  Distributor_selfActivity_editor,
  Distributor_selfActivity_log,
  Items_areaMarketPrice,
  Items_skuInfo,
  Items_areaMarketPrice_editor,
  Distributorfeedback,
  Vipitemslist,
  Wxappsetting,
  Kaquanrandom,
  Recharge_offline,
  Recharge_offline_editor,
  Recharge_offline_log,
  Long_invite,
  Export_yga,
  Third_oauth,
  // 企业微信
  // Workwx_auth,
  Workwx_list,
  Workwx_dep,
  Workwx_employee,
  Permanent_code,
  Third_app,
  Workwx_share_log,
  Workwx_contact,
  Workwx_contact_tag,
  Yga_sign,
  Workwx_groupmsg_list,
  Wechat_room,
  Workwx_moment,
  Bg_img,
  Code,
  Cashback,
  Spread_logs,
  Publicity_links,
  Publicity_qrcodes,
  Nzyyactivity,
  Publicity_rel_members,
  Merchants,
  Merchants_edit,
  Company_account,
  Company_account_edit,
  Credentials,
  Credential_types,
  Merchant_category,
  Marketingsendcouponlog,
  StoreshopitemanagementRelease,
  //环境变量配置
  Envconfig,
  Account_detail,
  Account_total,
  Billingtotal,
  Long_manufactor,
  Long_manufactor_log,
  Banlancelist,
  Merchantbanlance,
  Merchantapply,
  Billingtotal_notify,
  Freight,
  Freight_edit,
  Merchant_transfer,
  SetRandCardRule,
  Yikangcardtype,
  Yikangcard,
  Ordermonthurl,
  Ordercheck,
  Ordersendcard,
  Ordersendcard_editor,
  Goodspricereview,
  Goodspricereviewtitle,
  Goodspricereviewlist,
  Kaquanpackage,
  NewCustomer,
  NewCustomer_editor,
  NewCustomer_wechatlog,
  NewCustomer_userlog
}
// 如果路由通过页面传值那么需要定义当前值的字段名称
export let routesParamsKey = {
  ActivityList_editor: 'act_id',
  Shopstorelist_editor: 'wxShopId',
  Goodsphysical_editor: 'itemId',
  Goodsphysicalimage_editor: 'itemId',
  // PointGoods_editor:  'id',
  Basearticle_editor: 'wxShopId',
  Brandmaterial_editor: 'media_id',
  Servicegoods_editor: 'itemId',
  Shippingtemplates_editor: 'templatesId',
  Marketingbargain_editor: 'bargain_id',
  Marketingactivity_editor: 'type',
  Groupsindex_editor: 'groups_id',
  Groupsindex_detail: 'team_id',
  Groupsindex_team: 'groups_id',
  Marketingcommunity_editor: 'community_id',
  Marketingcommunityactivity_editor: 'activity_id',
  Marketingseckill_editor: 'seckill_id',
  Limitedtimesale_editor: 'seckill_id',
  Buyonesfreeones_editor: 'id',
  Marketingdeliveryorder_detail: 'delivery_id',
  Marketingsfulldiscount_editor: 'marketing_id',
  Marketingsfullminus_editor: 'marketing_id',
  Marketingsfullgift_editor: 'marketing_id',
  Marketingspluspricebuy_editor: 'marketing_id',
  Planting_editor: 'marketing_id',
  Shopwxshop_editor: 'wxShopId',
  Marketingpackage_editor: 'package_id',
  Goodslimit_editor: 'limit_id',
  Recharge_offline_editor: 'limit_id',
  Company_account_edit: 'id',
  Merchants_edit:'id',
  Distributor_selfActivity_editor:'id',
  Distributor_selfActivity_log_editor:'id',
  Coupon_activity_editor:'id',
  Goodspricereviewlist:'id',
}



// WEBPACK FOOTER //
// ./src/router/routers.js